/*
 * Atomz price - the compare-at, where there is a real one.
 *
 * The block renders compareAtPrice whenever the field exists, without checking
 * it is higher than the price. On the store this theme was first built against
 * 114 of 116 products carried a compareAtPrice equal to the price and none
 * carried a discount, so every card drew a struck-through number equal to the
 * one beside it -- a sale sign on a shop with no sale. The theme's answer was
 * to hide the element outright, which is right there and wrong here: this
 * catalog has real markdowns, and hiding them costs the shopper the one number
 * that says the shoe is cheaper than it was.
 *
 * So it is shown, and emptied only where it is not a markdown. The comparison
 * is on the rendered text of the two elements, parsed as numbers, because the
 * card is the app's markup and the price it drew is the only price that is
 * definitely the one on screen.
 *
 * FAILURE MODE: a number it cannot parse is left alone and drawn. Showing a
 * compare-at that turns out to be equal is a cosmetic mistake; hiding one that
 * is real is a missed sale.
 */
(function () {
  'use strict';

  var DEBOUNCE = 60;

  function num(el) {
    if (!el) return null;
    var s = String(el.textContent || '').replace(/[^0-9.,]/g, '');
    if (!s) return null;
    // "1,299.90" and "1.299,90" both mean the same thing; the last separator
    // with two digits after it is the decimal one.
    var m = s.match(/[.,](\d{2})$/);
    if (m) s = s.slice(0, s.length - 3).replace(/[.,]/g, '') + '.' + m[1];
    else s = s.replace(/[.,]/g, '');
    var n = parseFloat(s);
    return isFinite(n) ? n : null;
  }

  function pass() {
    var rows = document.querySelectorAll('.az-product-card-price');
    for (var i = 0; i < rows.length; i++) {
      var was = rows[i].querySelector('.az-compare-at-price');
      if (!was || was.getAttribute('data-az-checked') === was.textContent) continue;

      var now = num(rows[i].querySelector('.az-price'));
      var then = num(was);
      var real = now !== null && then !== null && then > now;

      was.classList.toggle('az-compare-at-price--none', !real);
      was.setAttribute('data-az-checked', was.textContent);
    }
  }

  var timer = null;
  function watch() {
    var host = document.querySelector('atomz-product-grid') || document.body;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(pass, DEBOUNCE);
    }).observe(host, { childList: true, subtree: true, characterData: true });
    pass();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
